import { useDxReportDrafts } from '../../../../hooks/useDxReportDrafts';
import type { TimelineEvent } from '../../../patient-files/actions/types';

type DxDraftStatus = TimelineEvent['status'];

// Mirrors the backend gates: pre-approve needs an editable draft, while Final review also
// takes the 'pending_review' rows older cases carry. An approved version never counts.
export const EDITABLE_DX_DRAFT: readonly DxDraftStatus[] = ['draft'];
export const OPEN_DX_DRAFT: readonly DxDraftStatus[] = ['draft', 'pending_review'];

export function useDxDraftRequiredHint(
    patientId: string,
    accepted: readonly DxDraftStatus[]
): string | null {
    const { drafts } = useDxReportDrafts(patientId);
    return drafts.some((d) => accepted.includes(d.status)) ? null : 'Save a Dx draft first';
}
